import digitalData from 'digital-data';
import { setAnalytics } from '../../../thd-analytics-utils';
import { SERVICES_QUOTE, QUOTE_DETAILS, SERVICES_QUOTE_DETAILS } from '../../../constants';

export function quoteViewer() {
  LIFE_CYCLE_EVENT_BUS.lifeCycle.on('quote-viewer.page-load', () => {
    digitalData.page = {
      pageInfo: {
        pageName: SERVICES_QUOTE_DETAILS,
        pageType: SERVICES_QUOTE,
      },
      category: {
        primaryCategory: QUOTE_DETAILS,
        subCategory1: SERVICES_QUOTE_DETAILS,
        subCategory2: SERVICES_QUOTE_DETAILS,
      },
    };
    setAnalytics(digitalData);
  });
}